export default "__VITE_ASSET__65c30fed__"